import { useState } from "react";
import { Loader2 } from "lucide-react";
import moment from "moment";

import { ConsultationPreview } from "components/ConsultationPreview/ConsultationPreview";
import { SearchInput } from "components/ui";

import { SortByButton } from "./SortByButton";
import styles from "./Table.module.css";

export const Table = ({ items, isLoading }) => {
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState("a-to-z");

  const sortedAndFilteredItems =
    items
      ?.sort((a, b) => {
        if (sorting === "a-to-z") {
          return a.title?.localeCompare(b.title);
        }
        return b.title?.localeCompare(a.title);
      })
      .filter(
        (item) =>
          item.title?.toLowerCase()?.includes(search.toLowerCase()) ||
          item.consultationNoteList
            ?.at(0)
            ?.note?.toLowerCase()
            ?.includes(search.toLowerCase())
      ) || [];

  const renderTableContent = () => {
    if (isLoading) {
      return (
        <div className={styles.emptyState}>
          <Loader2 className={styles.loadingSpinner} size={24} />
          <p className={styles.emptyStateTitle}>Loading data...</p>
          <p className={styles.emptyStateText}>
            Please wait while we fetch the consultations.
          </p>
        </div>
      );
    }

    if (sortedAndFilteredItems.length === 0) {
      return (
        <div className={styles.emptyState}>
          <p className={styles.emptyStateTitle}>No items found</p>
          <p className={styles.emptyStateText}>
            {search
              ? "Try adjusting your search or filters to find what you're looking for."
              : "There are no items to display at this time."}
          </p>
        </div>
      );
    }

    return (
      <ul className={styles.tableItems}>
        {sortedAndFilteredItems.map((item) => (
          <ConsultationPreview
            key={item.id}
            consultation={{
              date: moment(item?.startTime, "YYYY-MM-DD HH:mm"),
              title: item?.title || "Consultation",
              consultation: item?.consultationNoteList?.at(0)?.note,
              attachments: {
                refferrals: [],
                prescriptions: [],
              },
            }}
            text={
              item?.consultationNoteList?.at(0)?.note ||
              "No notes found for this consultation."
            }
          >
            {item.consultationStaff?.firstName &&
              item.consultationStaff?.lastName && (
                <div className={styles.consultationDoctorSection}>
                  <h3>Consultation professional</h3>
                  <p>
                    {item.consultationStaff?.firstName +
                      " " +
                      item.consultationStaff?.lastName}
                  </p>
                </div>
              )}
          </ConsultationPreview>
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className={styles.tableWarpper}>
        <div className={styles.table}>
          <div className={styles.tableTopBarWrapper}>
            <SearchInput
              value={search}
              onChange={setSearch}
              placeholder="Search"
              disabled={isLoading}
            />
            <SortByButton
              selectedItem={sorting}
              setSelectedItem={setSorting}
              disabled={isLoading}
            />
          </div>
          {renderTableContent()}
        </div>
      </div>
    </>
  );
};
